import React from 'react';
import '../css/howtouse.css';

function HowToUse() {
  return (
    <div className="howto-container">
      <h1 className="howto-title">How to Use the Platform</h1>

      {/* Public Users Section */}
      <section className="howto-section">
        <h2 className="howto-subtitle">For Visitors (Public Users)</h2>
        <ol className="howto-list">
          <li>Go to the <strong>Home</strong> page.</li>
          <li>Use the <strong>search bar</strong> to find companies by typing keywords like <em>restaurant</em>, <em>food</em>, <em>insurance</em>, etc.</li>
          <li>Browse the suggested companies that match your search.</li>
          <li>Click on any company to open a chat window.</li>
          <li>Start asking the company your questions directly.</li>
        </ol>

        {/* Video 1 – Chat Demo */}
        <div className="howto-video">
          <h3>Watch Demo: Chatting with a Company Assistant</h3>
          <div className="video-wrapper">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/iuS3_aHt4PU"
              title="QueryBox Chat Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      {/* Organizations Section */}
      <section className="howto-section">
        <h2 className="howto-subtitle">For Organizations</h2>
        <ol className="howto-list">
          <li>Click on <strong>Signup</strong> to create your company account.</li>
          <li>After signing up, you’ll be redirected to your <strong>Dashboard</strong>.</li>
          <li>From your Dashboard, upload your company documents (PDF, Word, TXT, etc.).</li>
          <li>Our system automatically updates your company’s knowledge base when you upload files — no extra steps required.</li>
          <li>Once uploaded, your company becomes searchable and available for public users to chat with instantly.</li>
          <li>Share your company bot via companyhandle.deyforyou.com</li>
        </ol>

        {/* Video 2 – Dashboard Demo */}
        <div className="howto-video">
          <h3>Watch Demo: Managing Your Company Dashboard</h3>
          <div className="video-wrapper">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/VilWuin9CIs"
              title="QueryBox Dashboard Demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HowToUse;


// import React from 'react';
// import '../css/howtouse.css';

// function HowToUse() {
//   return (
//     <div className="howto-container">
//       <h1 className="howto-title">How to Use the Platform</h1>

//       {/* Public Users Section */}
//       <section className="howto-section">
//         <h2 className="howto-subtitle">For Visitors (Public Users)</h2>
//         <ol className="howto-list">
//           <li>Go to the <strong>Home</strong> page.</li>
//           <li>Use the <strong>search bar</strong> to find companies by typing keywords like <em>restaurant</em>, <em>food</em>, <em>insurance</em>, etc.</li>
//           <li>Browse the suggested companies that match your search.</li>
//           <li>Click on any company to open a chat window.</li>
//           <li>Start asking the company your questions directly.</li>
//         </ol>
//       </section>

//       {/* Organizations Section */}
//       <section className="howto-section">
//         <h2 className="howto-subtitle">For Organizations</h2>
//         <ol className="howto-list">
//           <li>Click on <strong>Signup</strong> to create your company account.</li>
//           <li>After signing up, you’ll be redirected to your <strong>Dashboard</strong>.</li>
//           <li>From your Dashboard, upload your company documents (PDF, Word, TXT, etc.).</li>
//           <li>Our system automatically updates your company’s knowledge base when you upload files — no extra steps required.</li>
//           <li>Once uploaded, your company becomes searchable and available for public users to chat with instantly.</li>
//         </ol>
//       </section>
//     </div>
//   );
// }

// export default HowToUse;


